export default __webpack_public_path__ + "media/zurb/img/bryan/fav-posts/b2c_vs_b2b_customer_experience-f3d9d25d618608b4b691a0d1f6f36c5e.png";